import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ImportFail.module.scss';
import failImg from '../../../../../assets/images/fail.svg';
import ModalFooter from '../../../../../components/ModalFooter';

type Props = {
  onReTry: () => void;
  onCancel: () => void;
  label?: string;
}

const ImportFail: React.FC<Props> = ({ onReTry, onCancel, label }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <img className={styles.img} src={failImg} alt="fail" />
      <div className={styles.tip}>{label || t('operate_fail')}</div>
      <ModalFooter
        onCancel={onCancel}
        onConfirm={onReTry}
        confirmLabel={t('mm_try_again')}
      />
    </div>
  );
};

export default ImportFail;
